import { calculateForumScore } from './forumScore';
import type { ForumBase } from '../types/forum';

export type RankField = 'score' | 'members_count' | 'posts_count' | 'topics_count';

export function sortForumsByField(forums: ForumBase[], field: RankField): ForumBase[] {
  return [...forums].sort((a, b) => {
    if (field === 'score') {
      return (
        calculateForumScore(b.topics_count, b.posts_count, b.members_count, b.founded_year) -
        calculateForumScore(a.topics_count, a.posts_count, a.members_count, a.founded_year)
      );
    }
    return ((b[field] as number) ?? 0) - ((a[field] as number) ?? 0);
  });
}

export function getForumRank(
  forum: ForumBase,
  list: ForumBase[],
  field: RankField
): number {
  const sorted = sortForumsByField(
    list.filter((f) => f.is_active !== false),
    field
  );
  const idx = sorted.findIndex((f) => f.id === forum.id);
  return idx >= 0 ? idx + 1 : 0;
}

export function getCategoryPeers(forums: ForumBase[], category: string): ForumBase[] {
  return forums.filter((f) => f.is_active !== false && f.category === category);
}
